import React, { useContext, useState, useEffect } from "react";
import "./normal-login.component.scoped.sass";
import { useTranslation } from "react-i18next";
import { InputComponent } from "../input/input.component";
import { AuthContext } from "src/store";
import { Button, CircularProgress } from "@material-ui/core";
import { AuthService } from "src/services/auth/auth.service";
import { history } from "react-router-guard";
const authService: AuthService = new AuthService();

export const NormalLoginComponent = () => {
  const {
    validate,
    errors,
    loginError,
    email,
    password,
    setLoginError,
    code,
  } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState("login");
  const {
    email: emailError,
    password: passwordError,
    code: codeError,
  } = errors;
  const [t] = useTranslation();

  useEffect(() => {
    setLoginError(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  const validateEmail = (event: any) => {
    setLoginError(null);
    const value = event.target.value;
    return validate("email", value);
  };

  const validateCode = (event: any) => {
    setLoginError(null);
    const value = event.target.value;
    return validate("code", value);
  };

  const inputPassword = (event: any) => {
    setLoginError(null);
    const value = event.target.value;
    return validate("password", value);
  };

  const login = async () => {
    try {
      setLoading(true);
      await authService.login(email, password);
      history.push("/buildings");
    } catch (error) {
      return setLoginError("login-error");
    } finally {
      setLoading(false);
    }
  };

  const sendVerificationCode = async () => {
    try {
      setLoading(true);
      await authService.sendVerificationCodeForPasswordReset(email);
      setForm("password-reset");
    } catch (error) {
      return setLoginError("verification-code-error");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter' && !Object.keys(errors).length) {
      login();
    }
  }

  const resetPassword = async () => {
    try {
      setLoading(true);
      await authService.changePassword(email, code, password);
      setForm("login");
    } catch (error) {
      return setLoginError("change-password-error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="normal-login">
      <div className="label">{t("welcome-back")}</div>
      {form === "login" && (
        <form className="login-form" noValidate autoComplete="off" onKeyDown={handleKeyDown} >
          <InputComponent
            label="user"
            icon="user"
            validate={validateEmail}
            error={emailError}
          />
          <InputComponent
            label="password"
            icon="password"
            type="password"
            validate={inputPassword}
            error={passwordError}
          />
          {loginError && (
            <div className="login-error">
              {t(loginError)},
              <button
                className="btn link-style"
                onClick={setForm.bind(null, "send-code")}
              >
                {t("forget-password")}
              </button>
            </div>
          )}
          <Button
            variant="contained"
            className="btn btn-warning"
            onClick={login}
            disabled={Object.keys(errors).length > 0 || loading}
          >
            <span className="login-btn-content">
              {!loading && t("login")}
              {loading && <CircularProgress color="primary" />}
            </span>
          </Button>
        </form>
      )}
      {form === "send-code" && (
        <form noValidate autoComplete="off">
          <InputComponent
            label="user"
            icon="user"
            validate={validateEmail}
            error={emailError}
          />
          {loginError && (
            <div className="login-error">
              {t(loginError)},
              <button
                className="btn link-style"
                onClick={setForm.bind(null, "forget-password")}
              >
                {t("forget-password")}
              </button>
            </div>
          )}
          <div className="multiple-buttons">
            <Button
              variant="contained"
              className="btn btn-warning"
              onClick={sendVerificationCode}
              disabled={Object.keys(errors).length > 0 || loading}
            >
              <span className="login-btn-content">
                {!loading && t("send code")}
                {loading && <CircularProgress color="primary" />}
              </span>
            </Button>
            <Button
              variant="contained"
              className="btn btn-warning"
              onClick={setForm.bind(null, "login")}
            >
              <span className="login-btn-content">{t("back")}</span>
            </Button>
          </div>
        </form>
      )}
      {form === "password-reset" && (
        <form noValidate autoComplete="off">
          <InputComponent
            type="number"
            maxlength="6"
            label="verification code"
            icon="user"
            validate={validateCode}
            error={codeError}
          />
          <InputComponent
            label="new password"
            icon="password"
            type="password"
            validate={inputPassword}
            error={passwordError}
          />
          <div className="login-error">{t(loginError)}</div>
          <div className="multiple-buttons">
            <Button
              variant="contained"
              className="btn btn-warning"
              onClick={resetPassword}
              disabled={Object.keys(errors).length > 0 || loading}
            >
              <span className="login-btn-content">
                {!loading && t("reset")}
                {loading && <CircularProgress color="primary" />}
              </span>
            </Button>
            <Button
              variant="contained"
              className="btn btn-warning"
              onClick={setForm.bind(null, "login")}
            >
              <span className="login-btn-content">{t("back")}</span>
            </Button>
          </div>
        </form>
      )}
    </div>
  );
};
